import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import user from '../components/user.vue'

// 路由懒加载
const Home2 = () => import('../views/home2.vue');
const Index = () => import('../views/tabbar/Index.vue');
const Find = () => import('../views/tabbar/Find.vue');
const Cart = () => import('../views/tabbar/Cart.vue');
const Profile = () => import('../views/tabbar/Profile.vue');

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/user/:userId',
    name: 'user',
    component: user
  },
  {
    path: '/home',
    name: 'home',
    component: Home
  },
  {
    path: '/home2',
    name: 'home2',
    component: Home2,
	children: [
			{ path: '',
			  component: Index,
			},
	        {
	          path: 'index',
	          name: 'index',
	          component: Index
	        },
	        {
	          path: 'find',
	          name: 'find',
	          component: Find
	        },
	        {
	          path: 'cart',
	          name: 'cart',
	          component: Cart
	        },
	        {
	          path: 'profile',
	          name: 'profile',	
	          component: Profile
	        },
	      ]
	
  },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
